/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Request for add or update bank account
 * @export
 * @interface AddOrUpdateBankAccountRequest
 */
export interface AddOrUpdateBankAccountRequest {
    /**
     * Unique identifier of the financial channel
     * @type {number}
     * @memberof AddOrUpdateBankAccountRequest
     */
    id?: number;
    /**
     * the code bic of bank
     * @type {string}
     * @memberof AddOrUpdateBankAccountRequest
     */
    bic?: string;
    /**
     * the iban of bank account
     * @type {string}
     * @memberof AddOrUpdateBankAccountRequest
     */
    iban?: string;
    /**
     * Indicate if the appointment type is active
     * @type {boolean}
     * @memberof AddOrUpdateBankAccountRequest
     */
    active?: boolean;
    /**
     * True if the bank account can be edited
     * @type {boolean}
     * @memberof AddOrUpdateBankAccountRequest
     */
    editable?: boolean;
}

/**
 * Check if a given object implements the AddOrUpdateBankAccountRequest interface.
 */
export function instanceOfAddOrUpdateBankAccountRequest(value: object): value is AddOrUpdateBankAccountRequest {
    return true;
}

export function AddOrUpdateBankAccountRequestFromJSON(json: any): AddOrUpdateBankAccountRequest {
    return AddOrUpdateBankAccountRequestFromJSONTyped(json, false);
}

export function AddOrUpdateBankAccountRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddOrUpdateBankAccountRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'bic': json['bic'] == null ? undefined : json['bic'],
        'iban': json['iban'] == null ? undefined : json['iban'],
        'active': json['active'] == null ? undefined : json['active'],
        'editable': json['editable'] == null ? undefined : json['editable'],
    };
}

export function AddOrUpdateBankAccountRequestToJSON(json: any): AddOrUpdateBankAccountRequest {
    return AddOrUpdateBankAccountRequestToJSONTyped(json, false);
}

export function AddOrUpdateBankAccountRequestToJSONTyped(value?: AddOrUpdateBankAccountRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'bic': value['bic'],
        'iban': value['iban'],
        'active': value['active'],
        'editable': value['editable'],
    };
}

